import styled from 'styled-components';
import { Card, CardActionArea } from '@prisjakt/ui/card';

export const StyledCard = styled(Card)`
  height: 100%;
  background-color: ${p => p.theme.bg.primary};
`;

export const StyledCardActionArea = styled(CardActionArea)`
  height: 100%;
  cursor: pointer;
`;
